export default "__VITE_ASSET__88544bd8__"